import {
    AvailabilityAction,
} from '@vfde-sails/availability';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { OverlayView, ProductType } from '../../enum';
import { setLoading, setOverlayVisibility, setSelectedProduct } from '../App/action';
import { ProductAvailability } from './interface';
import { selectAvailability } from './selector';
import type {
    setAddresses,
    setAvailabiltyResult,
    setError,
} from '@vfde-sails/availability/dist/types/actions';
import { trackErrorHandler, trackForm } from '../../tracking/generator';
import { TrackingFormStepName } from '@vfde-sails/tracking';

export function* setAddressesSaga (action: ReturnType<typeof setAddresses>) {
    if (action.addresses.length === 1) {
        return;
    }

    yield put(setLoading(false));
}

export function* changeAddressSaga () {
    yield put(setOverlayVisibility(OverlayView.AVAILABILITY_FORM));
    yield call(trackForm, TrackingFormStepName.Show);
}

export function* checkAddressSaga () {
    yield put(setLoading(true));
    yield call(trackForm, TrackingFormStepName.Start);
}

export function* setAvailabilityResultSaga (action: ReturnType<typeof setAvailabiltyResult>) {
    const availability: ProductAvailability = yield select(selectAvailability);

    if (availability.cableTv && !availability.netTv) {
        yield put(setSelectedProduct({ type: ProductType.CABLE }, false));
    }

    if (availability.netTv && !availability.cableTv) {
        yield put(setSelectedProduct({ type: ProductType.NET }, false));
    }

    if (!action.isSeamless) {
        yield put(setOverlayVisibility(OverlayView.AVAILABILITY_RESULT));
        yield call(trackForm, TrackingFormStepName.Complete);
    }

    yield put(setLoading(false));
}

export function* setErrorSaga (action: ReturnType<typeof setError>) {
    yield put(setLoading(false));
    yield call(trackErrorHandler, action.error);
}

export default function* addressValidationSaga () {
    yield takeLatest(AvailabilityAction.CheckAddress, checkAddressSaga);
    yield takeLatest(AvailabilityAction.ChangeAddress, changeAddressSaga);
    yield takeLatest(AvailabilityAction.SetAddresses, setAddressesSaga);
    yield takeLatest(AvailabilityAction.SetAvailabilityResult, setAvailabilityResultSaga);
    yield takeLatest(AvailabilityAction.SetError, setErrorSaga);
}
